import InboundRedemptionFollowUpCapturedDocument from "./InboundRedemptionFollowUpCapturedDocument";

export default class InboundFollowUpRequirementDocument {

    constructor(json) {
        this.id = json["id"];
        this.documentPurpose = json["document-purpose"];
        this.documentPurposeDisplayValue = json["document-purpose-display-value"];
        this.status = json["status"];
        this.capturedDocument = new InboundRedemptionFollowUpCapturedDocument(json["captured-document"]);
    }
}